export enum interfaceEnum {
    /**
     * 图片识别
     */
    Image = 'recognize/image',

    /**
     * 手势识别
     */
    Gesture = 'recognize/gesture',

    /**
     * 授权
     */
    Auth = 'danoneri/auth/token',

    /**
     * 上传埋点
     */
    Report = 'danoneri/event/report',

    /**
     * 文字识别
     */
    Text = 'recognize/text',
}